module.exports = __webpack_public_path__ + "img/resource-manage.a07dd79c.png";